import { memo, useCallback } from "react";

import debounce from "debounce";
import { useFormContext, useWatch } from "react-hook-form";
import useDeepCompareEffect from "use-deep-compare-effect";

type Props = {
  defaultValues?: any;
  onSubmit: any;
  debounceTime?: number;
  ignoreDirty?: boolean;
  immediate?: boolean;
};

export const AutoSaveForm = memo(
  ({
    defaultValues,
    onSubmit,
    debounceTime = 1000,
    ignoreDirty = false,
    immediate = false,
  }: Props) => {
    const methods = useFormContext();

    // Save if this function is called and then not called again within 1000ms
    // eslint-disable-next-line
    const debouncedSave = useCallback(
      debounce(
        () => {
          methods.handleSubmit(onSubmit)();
        },
        debounceTime,
        { immediate },
      ),
      [onSubmit],
    );

    const watchedData = useWatch({
      control: methods.control,
      defaultValue: defaultValues,
    });

    useDeepCompareEffect(() => {
      if (ignoreDirty || methods.formState.isDirty) {
        debouncedSave();
      }
    }, [watchedData]);

    return null;
  },
);
